import React from 'react';
import { Button, Cascader, Col, Icon, Input, message, Modal, Radio, Row } from 'antd';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import SpecTableSortingRules from './spec-table-sorting-rules';

import { 
	_getCategorySpecTemplate,
	_getCategorySpecTable,
	_getUnitsOfMeasurements,
	_postCategoryIndexSpecTableData,
	_postCategorySpecHeaderTemplate,
	_postCategorySpecTableTemplate,
	_postCategorySpecType
} from '../../../services';

const RadioGroup = Radio.Group;

export const renderSpecTableHeaderCell = ( cell ) => {

	let headerCell = cell.value;

	if( cell.unit && cell.unit !== "" ){
		headerCell = `${headerCell} (${cell.unit[1]})`;
	}

	return headerCell;

}

class CategorySpecs extends React.Component{

	render(){
		
		return (
			<Modal 
				maskClosable={false} 
				width={1080} 
				onCancel={ this.props.closeSpecTableEditor } 
				onOk={ this.handleIndexData }
				visible={true}
				okText={"ReIndex"}
				cancelText={"Close"}
				okButtonProps={{ disabled: this.state.specTableHeaders.length === 0 }}>

				{/* <CategoryGeneralDescription /> */}

				{/* <Row gutter={8} type="flex">
					<Col>
						<h2>General Description for {this.props.subKebabCase}</h2>
					</Col>

					<Col>
						<Button 
							onClick={ this.handleSaveHeaderTemplate } 
							type="primary"
							icon="save">

							Save

						</Button>
					</Col>
				</Row> */}

				{/* <Row gutter={8}>

					<Col span={16}>
						<TextArea 
							value={ this.state.description }
							onChange={ e => this.setState({ description: e.target.value }) }
							rows={11} 
							placeholder={`Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus feugiat augue vitae quam rhoncus tristique. Vivamus facilisis tellus ut nisl tincidunt dictum. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Sed convallis nibh a consectetur eleifend. Fusce posuere mauris libero, ac pulvinar quam feugiat id. Sed in pretium tortor, vitae placerat nisi. Nullam malesuada quam ac lorem porttitor dictum. Nam nec orci vitae eros elementum porttitor non non ligula. Pellentesque eu ligula libero. Morbi augue tortor, lobortis quis venenatis ut, mollis id massa.
						
Donec nec ligula eget est dignissim varius nec ac sem. In ac molestie ipsum. Suspendisse rhoncus euismod quam, vulputate ultrices sapien lobortis ac. Ut imperdiet ante vel tellus feugiat fringilla quis ut risus. Sed sed cursus elit, in iaculis eros. Curabitur sit amet turpis metus. Cras pulvinar erat sed sapien tempor, in fermentum quam mattis.`} />
					</Col>

					<Col span={8}>
						<Input value={this.state.image} onChange={ e => this.setState({ image: e.target.value })}/>
			
						<Row style={{ width: 200, height: 200 }} type="flex" justify="center" align="middle">
							<Col>
								{
									this.state.image && (
										<img style={{ maxWidth: 200, maxHeight: 200 }} src={this.state.image}/>
									)
								}
							</Col>
						</Row>
					
					</Col>
				</Row> */}


				<DragDropContext
					onDragEnd={ this.handleOnDragEnd }
				>
					<Row style={{ marginTop: 16 }} gutter={8} type="flex">
						<Col>
							<h2>Define Header Template for {this.props.subKebabCase}</h2>
						</Col>

						<Col>
							<Button 
								onClick={ this.handleOnAddColumn } 
								icon="plus-square">

								Add a column

							</Button>
						</Col>

						<Col>
							<Button 
								onClick={ this.handleSaveHeaderTemplate } 
								type="primary"
								icon="save">

								Save

							</Button>
						</Col>
					</Row>
			
					{ this.renderSpecsHeader() }

					<Row gutter={8} type="flex">
						<Col>
							<h2>Define Spec Table Headers for {this.props.subKebabCase}</h2>
						</Col>

						<Col>
							<Button 
								onClick={ this.handleSaveSpecTableTemplate } 
								type="primary"
								icon="save">

								Save

							</Button>
						</Col>

					</Row>

					{ this.renderSpecsTableTemplate() }
				
				</DragDropContext>

				<Row gutter={8} type="flex">
				
					<Col>
						<h2>Spec Table Type</h2>
					</Col>

					<Col>
						<Button 
							onClick={ this.handleSaveSpecType } 
							type="primary"
							icon="save">

							Save

						</Button>
					</Col>

				</Row>
			
				<RadioGroup 
					onChange={ this.handleOnChangeSpecType }
					value={this.state.specType} 
					options={["Size Chart", "Spec Sheet", "Size Chart / Spec Sheet"]}  />

				<Row gutter={8} type="flex" style={{ marginTop: 24 }}>
					<Col>
						<h2>Spec Table Preview for {this.props.subKebabCase}</h2>
					</Col>
				</Row>

				<SpecTableSortingRules 
					subKebabCase={ this.props.subKebabCase }
					specTableHeaders={ this.state.specTableHeaders } />

				{ this.renderSpecTablePreview() }

			</Modal>
		)
	}

	// renderFourDpIfNumber = ( value ) => {

	// 	if ( isNaN(value) ){
	// 		return value;
	// 	}

	// 	return value.toFixed(4);

	// }
	renderHeaderEditor = ({ index, droppableId, header }) => {
		return (
			<div style={{ padding: 8 }}>
				<Row type="flex" align="middle" justify="space-between">
					<Col> 
						{ index === 0 && droppableId === "spec-table-template" && (
							<div style={{ cursor: "pointer" }} >
								<Icon 
									onClick={ () => this.handleTogglePrimaryKey() }
									theme="twoTone" 
									twoToneColor={ header.primaryKey? "#FFA500": "#595959" } type="star" />
							</div>
						)}
					</Col>

					<Col> 
						<Icon type="drag" /> 
					</Col>

					<Col> 
						<div style={{ cursor: "pointer" }} >
							<Icon
								theme="twoTone" twoToneColor="#ff0000" 
								onClick={ () => this.handleOnClickDelete({
									index,
									droppableId
								})} 
								type="delete" />
						</div>
					</Col>
				</Row>

				<Input 
					disabled={ droppableId === "spec-table-template" }
					style={{ width: 180, marginBottom: 8 }}
					placeholder="Header Name"
					onChange={ ( e ) => this.handleOnChangeHeader({ 
							inputType: 'value', 
							value: e.target.value, 
							index,
							droppableId
						}) 
					}
					value={header.value} /><br/>
				
				<Cascader 
					style={{ width: 180 }}
					placeholder="Units"
					value={header.unit}
					onChange={ ( value ) => this.handleOnChangeHeader({ 
							inputType: 'unit', 
							value: value, 
							index,
							droppableId
						}) 
					}
					options={this.state.unitOfMeasurements}/>

			</div>
		)
	}

	renderSpecsHeader = ( ) => {
		
		const { loadingHeaders, headers } = this.state;

		if( loadingHeaders ){
			return "loading...";
		}

		return (
			

				<Droppable direction="horizontal" droppableId="spec-headers" type="specs">
					{(provided, snapshot) => (
						<div
							ref={provided.innerRef}
							style={{ 
								backgroundColor: snapshot.isDraggingOver ? 'whitesmoke' : 'white',
								display: 'flex',
								overflow: "scroll",
								padding: 8,
								height: 125
							}}
							{...provided.droppableProps}
							>
								{/* <Row type="flex" gutter={16}> */}
									{headers.map( 
										(header, index) => {
											return (
												// <Col>
													<Draggable key={index} draggableId={`draggable-${index}-sh`} index={ index }>
														{(provided, snapshot) => (
															<div
															ref={provided.innerRef}
															{...provided.draggableProps}
															{...provided.dragHandleProps}
															>

																{
																	this.renderHeaderEditor({
																		index, 
																		header,
																		droppableId: "spec-headers"
																	}) 
																}

															</div>
														)}
													</Draggable>
												// </Col>
											)
										}
									)}
								{/* </Row> */}
								
								<div style={{ height: "100%", color: "transparent" }}>abcdefghijklmnopqrstuvwxyz</div>
								{provided.placeholder}
						</div>
					)}
				</Droppable>
				

		)

	}

	renderSpecsTableTemplate = () => {

		const { loadingHeaders, specTableHeaders } = this.state;

		if( loadingHeaders ){
			return "loading...";
		}

		return (
			<Droppable direction="horizontal" droppableId="spec-table-template" type="specs">
				{(provided, snapshot) => (
					<div
						ref={provided.innerRef}
						style={{ 
							backgroundColor: snapshot.isDraggingOver ? 'whitesmoke' : 'white',
							display: 'flex',
							overflow: "scroll",
							padding: 8,
							height: 125
						}}

						{...provided.droppableProps}

						>

							{specTableHeaders.map( 
								(header, index) => {
									return (
										// <Col>
											<Draggable key={index} draggableId={`draggable-${index}-st`} index={ index }>
												{(provided, snapshot) => (
													<div
													ref={provided.innerRef}
													{...provided.draggableProps}
													{...provided.dragHandleProps}
													>

														{
															this.renderHeaderEditor({
																index, 
																header,
																droppableId: "spec-table-template"
															}) 
														}

													</div>
												)}
											</Draggable>
										// </Col>
									)
								}
							)}
						{/* </Row> */}
						
						<div style={{ height: "100%", color: "transparent" }}>abcdefghijklmnopqrstuvwxyz</div>
						{provided.placeholder}
					</div>
				)}
			</Droppable>
		)
	}
 
	renderSpecTablePreview = () => {

		if( this.state.specTable.length === 0 ){
			return null;
		}

		return (
			<table style={{ marginTop: 8 }} className="table-preview">
				<tbody>
					<tr>
						{this.state.specTableHeaders.map(
							cell => (
								<th>
									{ renderSpecTableHeaderCell(cell) }
								</th>
							)
						)}
					</tr>
					{this.state.specTable.map(
						row => (
							<tr>
								{row.map(
									cell => <td>{ cell }</td>
								)}
							</tr>
						)
					)}
				</tbody>
			</table>
		)
	}

	constructor( props ){
		super(props);

		this.state = {
			headers: [],
			specTableHeaders: [],
			loadingHeaders: true,
			unitOfMeasurements: [],
			specTable: [],
			specType: ''
		}

		this.headerObject = {
			value:'',
			unit: '',
		}

		this.specTableHeaderObject = {
			value: '',
			unit: '',
		}
		
	}

	componentDidMount(){

		// GET SPEC TABLE SETTINGS
		_getCategorySpecTemplate( this.props.subKebabCase )
			.then( res => {
				this.setState({ 
					specType: res.data.specType,
					loadingHeaders: false, 
					headers: res.data.headers.map(
						header => {
							
							if( header.unit && header.measure ){
								header.unit = [ header.measure, header.unit ]
							}

							return header;

						}
					),
					specTableHeaders: res.data.specTableHeaders.map(
						header => {
							
							if( header.unit && header.measure ){
								header.unit = [ header.measure, header.unit ]
							}

							return header;

						}
					)
				});
			});

		// GET THE ACTUAL SPEC TABLE DATA
		_getCategorySpecTable( this.props.subKebabCase )
			.then( res => {
				this.setState({ specTable: res.data.specTable })
			})
		
		// GET THE UNIT OF MEASUREMENTS
		_getUnitsOfMeasurements()
			.then( res => {
				this.setState({ unitOfMeasurements: res.data });
			})

		// _getCategorySpecHeaders( this.props.subKebabCase )
		// 	.then( res => {
				
				// this.setState({ headers: Object.keys()res.data.columns })

			// })
	}

	handleIndexData = () => {

		// _postIndexData()

		if( this.state[`specTableHeaders-edited`] ){
			let cfm = window.confirm('Are you sure you want to index? You have not saved the new spec table template');

			if( !cfm ){
				return;
			}
		}

		let loadingMsg = message.loading("Indexing.. This may take a minute...", 0);

		_postCategoryIndexSpecTableData( this.props.subKebabCase )
			.then( res => {

				_getCategorySpecTable( this.props.subKebabCase )
					.then( res => {

						loadingMsg();

						message.success("Spec Table Reindexed!");
						this.setState({ specTable: res.data.specTable })
					})
				// this.setState({ specTable: res.data.specTable })

				// console.log
			})

	}

	handleOnAddColumn = () => {
		this.setState({ 
			headers: [
				[this.headerObject],
				...this.state.headers
			]
		})
	}

	handleOnChangeHeader = ({ value, inputType, index, droppableId }) => {

		let headerField = "";

		switch( droppableId ){

			case "spec-table-template":
				headerField = "specTableHeaders";
				break;

			case "spec-headers":
				headerField = "headers";
				break;

			default:
				headerField = "headers";
				break;
		}

		this.setState({
			[`${[headerField]}-edited`]: true,
			[headerField]: this.state[headerField].map(
				( header, j ) => {
					
					if( index === j ){
						return {
							...header,
							[inputType]: value
						}
					}

					return header;
				}
			)
		})
	}

	handleOnChangeSpecType = ( e ) => {

		this.setState({ specType: e.target.value });

	}

	handleOnClickDelete = ({ 
		droppableId,
		index 
	}) => {

		switch( droppableId ){
			case 'spec-headers':
				this.setState({
					headers: this.state.headers.filter( (header, i ) => i !== index )
				})
				break;

			case 'spec-table-template':
				this.setState({
					specTableHeaders: this.state.specTableHeaders.filter( (header, i ) => i !== index )
				})
				break;

			default: 
				break;
		}
		
	}

	handleOnDragEnd = ( result ) => {

		if (!result.destination) {
      return;
    }

		if( result.destination.droppableId === "spec-table-template" && 
				result.source.droppableId === "spec-headers"
		){
			
			// dragged and dropped within same component
			let sourceSpec = this.state.headers[result.source.index];

			this.setState({
				specTableHeaders: [
					...this.state.specTableHeaders.slice(0, result.destination.index),
					sourceSpec,
					...this.state.specTableHeaders.slice(result.destination.index)
				]
			
			})
			// console.log( result );
			// result.source.index,
      // result.destination.index
			

		} else if( result.destination.droppableId === result.source.droppableId ) {
 
			// dragged and dropped within same component
			// todo dnd specTableHeaders
			switch( result.destination.droppableId ){
				case 'spec-headers':

					const headers = this.handleReorderItems(
						this.state.headers,
						result.source.index,
						result.destination.index
					);
			
					this.setState({
						headers,
					});

					break;

				case 'spec-table-template':

					const specTableHeaders = this.handleReorderItems(
						this.state.specTableHeaders,
						result.source.index,
						result.destination.index
					).map( (header, index ) => {

						if( index > 0 && header.primaryKey){
							header.primaryKey = false;
						}

						return header;

					});
			
					this.setState({
						specTableHeaders,
					});

					break;

				default:
					break;

			}

		}

	}

	// a little function to help us with reordering the result
	handleReorderItems = (list, startIndex, endIndex) => {
		const result = Array.from(list);
		const [removed] = result.splice(startIndex, 1);
		result.splice(endIndex, 0, removed);

		return result;
	};

	handleSaveHeaderTemplate = ( ) => {

		let loadingMsg = message.loading('Saving New Header Template..');

		_postCategorySpecHeaderTemplate({
			subKebabCase: this.props.subKebabCase,
			data: this.state.headers
		})
			.then( res => {
				
				loadingMsg();
				this.setState({[`headers-edited`]: false});
				message.success('Saved new header template!');

			})
	}

	handleSaveSpecTableTemplate = () => {
		let loadingMsg = message.loading('Saving new spec table template..');

		_postCategorySpecTableTemplate({
			subKebabCase: this.props.subKebabCase,
			data: this.state.specTableHeaders
		})
			.then( res => {
				
				loadingMsg();
				this.setState({[`specTableHeaders-edited`]: false});
				message.success('Saved new spec table template!');

			})
	}

	handleSaveSpecType = () => {

		let loadingMsg = message.loading('Saving new spec type..');

		_postCategorySpecType({
			subKebabCase: this.props.subKebabCase,
			specType: this.state.specType
		})
			.then( res => {
				
				loadingMsg();
				message.success('Saved new spec type!');

			});

	}

	handleTogglePrimaryKey = () => {
		
		let primaryKeyTrue = this.state.specTableHeaders[0].primaryKey? true : false;

		this.setState({
			[`specTableHeaders-edited`]:true,
			specTableHeaders: this.state.specTableHeaders.map(
				( header, index ) => {

					if( index === 0 ){
						header.primaryKey = !primaryKeyTrue;
					}

					return header;

				}
			)
		})


	}


}

export default CategorySpecs;


// WEBPACK FOOTER //
// ./src/components/category/category-specs/index.js